import vine from '@vinejs/vine'
import { orgRichTextVine } from '~/validators/orgRichText'
import { createAndUpdateValidator, orgLibField } from '~/validators/orgFields'

function equipeContactsField(optionalMembers = false) {
  const member = optionalMembers
    ? vine.object({
        conLib: vine.string().trim().maxLength(255).nullable().optional(),
        conChamp: vine.string().trim().nullable().optional(),
      })
    : vine.object({
        conLib: vine.string().trim().maxLength(255),
        conChamp: vine.string().trim(),
      })
  return vine.array(member).nullable().optional()
}

const equipeValidators = createAndUpdateValidator(function equipeSchema() {
  return vine.object({
    dirLib: orgLibField(),
    domLib: orgLibField(),
    ageLib: orgLibField(),
    equLib: orgLibField(),
    equDesc: orgRichTextVine().nullable(),
    equMis: orgRichTextVine().nullable(),
    contacts: equipeContactsField(),
  })
})

export const createEquipeValidator = equipeValidators.create
export const updateEquipeValidator = equipeValidators.update

export const patchEquipeValidator = vine.create(
  vine.object({
    dirLib: orgLibField().nullable().optional(),
    domLib: orgLibField().nullable().optional(),
    ageLib: orgLibField().nullable().optional(),
    equLib: orgLibField().nullable().optional(),
    equDesc: orgRichTextVine().nullable().optional(),
    equMis: orgRichTextVine().nullable().optional(),
    contacts: equipeContactsField(true),
  })
)
